import { fetchWithTenant } from '../utils/apiClient';

const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:4010/api';

/**
 * Mark a job as not interested
 */
export const markNotInterested = async (jobPostingId, reason = 'Not interested', notes = '') => {
  const response = await fetchWithTenant(`${API_BASE_URL}/not-interested-jobs`, {
    method: 'POST',
    body: JSON.stringify({ jobPostingId, reason, notes }),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || 'Failed to mark job as not interested');
  }

  return response.json();
};

/**
 * Remove not interested mark from a job
 */
export const removeNotInterested = async (jobPostingId) => {
  const response = await fetchWithTenant(`${API_BASE_URL}/not-interested-jobs/${jobPostingId}`, {
    method: 'DELETE',
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || 'Failed to remove not interested mark');
  }

  return response.json();
};

/**
 * Get all not interested job IDs for current user
 */
export const getNotInterestedJobs = async () => {
  const response = await fetchWithTenant(`${API_BASE_URL}/not-interested-jobs`);

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || 'Failed to fetch not interested jobs');
  }

  return response.json();
};

/**
 * Check if a job is marked as not interested
 */
export const isJobNotInterested = async (jobPostingId) => {
  const response = await fetchWithTenant(`${API_BASE_URL}/not-interested-jobs/${jobPostingId}/check`);

  if (!response.ok) {
    return false;
  }

  const data = await response.json();
  return data.isNotInterested;
};
